import { AODA } from '@core/utilities/aoda';
import { Component, ElementRef, Injector, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { ActivatedRoute } from '@angular/router';
import { Assessment } from '@shared/models/records/assessment.model';
import { DatabaseIndexNameType } from '@shared/models/common/database-index-name.model';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-assessment-record',
  templateUrl: './assessment-record.component.html',
  styleUrls: ['./assessment-record.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AssessmentRecordComponent extends BaseComponent implements OnInit, OnDestroy {

    record: Assessment;
    searchTerms: string;

    constructor(
        private injector: Injector,
        private route: ActivatedRoute,
        private el: ElementRef,
        private r2: Renderer2) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.initRecord();
        this.loadOntarioExpandCollapse();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngAfterViewInit(): void {
        AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
    }

    private initRecord() {
        if(!history.state.data) {
            this.record = JSON.parse(this.searchResultsCache.getRecord());
        } else {
            this.record = history.state.data;
            this.searchTerms = history.state.searchTerms;
            this.searchResultsCache.setRecord(this.record);
        }

        const breadcrumb = {
            name: this.fileId,
            prefix: 'assessment.record',
            component: 'AssessmentRecordComponent',
        }      
        this.breadcrumbService.addBreadcrumb(breadcrumb);
    }

    get fileId() {
        return this.record.file_id;
    }

    get fileType() {
        return this.record.file_type;
    }

    get residentGeologistDistrict() {
        return this.record.resident_geologist_district;
    }

    get propertyNames(): any[] {
        return this.record.property_names;
    }

    get primaryTownship() {
        return this.record.primary_township;
    }

    get secondaryTownships(): any[] {
        return this.record.secondary_townships;
    }

    get nts(): any[] {
        return this.record.nts;
    }

    get yearFrom() {
        return this.record.year_from;
    }

    get yearTo() {
        return this.record.year_to;
    }

    get performedFor(): any[] {
        return this.record.performed_for;
    }

    get totalValueOfWorkApproved() {
        return this.record.total_value_of_work_approved;
    }

    get drill_hole_count() {
        return this.record.drill_hole_count;
    }

    get reports() {
        if(this.record.technical_reports && this.record.technical_reports.length > 0) {
            return true;
        }
        return false;
    }

    get otherDocuments() {
        if(this.record.maps && this.record.maps.length > 0) {
            return true;
        }
        return false;
    }

    get fileIdentifiers() {
        if(this.record.file_identifiers && this.record.file_identifiers.length > 0) {
            return true;
        }
        return false;
    }

    get workTypes() {
        if(this.record.work_types && this.record.work_types.length > 0) {
            return true;
        }
        return false;
    }

    get commodities() {
        if(this.record.commodities && this.record.commodities.length > 0) {
            return true;
        }
        return false;
    }

    get authors() {
        if(this.record.authors && this.record.authors.length > 0) {
            return true;
        }
        return false;
    }

    get location() {
        if(this.record.location && this.record.location.length > 0) {
            return true;
        }
        return false;
    }

    get claimHolders() {
        if(this.record.claim_holders && this.record.claim_holders.length > 0) {
            return true;
        }
        return false;
    }

    get claims() {
        if(this.record.claims && this.record.claims.length > 0) {
            return true;
        }
        return false;
    }

    get contact_rgp() {
        return this.record.contact_rgp[0];
    }

    get databaseIndex(): string {
        return DatabaseIndexNameType.assessment;
    }

    get downloadsAZStorage(): string {
        return environment.azure_blob_storage + DatabaseIndexNameType.assessment + '/' + this.fileId;
    }

    get drillHoleSummaryPersistentLink(): string {
        return environment.application_url + "persistent-linking?" + DatabaseIndexNameType.drillHoles + "=" + this.fileId;
    }

}